<template>
    <div class="pt-0 pb-3 px-5 m-0">
      <div class="is-flex is-align-items-center is-justify-content-left">
        <div class="component-order-state__tag-container is-flex is-align-items-center is-justify-content-left is-flex-shrink-0">
          <span class="tag tag--step is-success is-rounded is-large is-light"><span class="icon icon--0"><i class="fas fa-check is-small"></i></span></span>
        </div>
        <p class="has-text-grey"><slot /></p>
      </div>
    </div>
</template>

<script>
export default {}
</script>

<style lang="sass">
 .tag--step
   width: 2.5rem !important
   height: 2.5rem !important
</style>
